import { styled } from '@mui/material/styles';
import { Box, IconButton, InputBase } from '@mui/material';
import { theme } from 'config/theme';
import SearchLineIcon from 'remixicon-react/SearchLineIcon';
import ListUnorderedIcon from 'remixicon-react/ListUnorderedIcon';
import Sort, { SortMenuType } from 'components/utils/Sort';
import { Dispatch, forwardRef, KeyboardEvent, SetStateAction } from 'react';
import CloseCircleFillIcon from 'remixicon-react/CloseCircleFillIcon';

type InsightsSearchProps = {
  searchInputRefValue?: HTMLInputElement | null;
  menu?: SortMenuType;
  onClearSearch?: () => void;
  onSearchKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void;
  setMenu?: Dispatch<SetStateAction<SortMenuType>>;
};

const InsightsSearch = forwardRef<HTMLInputElement, InsightsSearchProps>(
  ({ menu, onClearSearch, onSearchKeyDown, setMenu, searchInputRefValue }, inputRef) => {
    const handleClear = () => {
      if (searchInputRefValue?.value) {
        searchInputRefValue.value = '';
      }
      onClearSearch?.();
    };

    return (
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box width="60%">
          <SearchInput
            inputRef={inputRef}
            autoFocus
            fullWidth
            placeholder="Search..."
            startAdornment={
              <SearchLineIcon
                size={20}
                color={theme.palette.custom.steel}
                style={{ marginRight: 8 }}
              />
            }
            onKeyDown={onSearchKeyDown}
            onBlur={() => {
              if (searchInputRefValue && !searchInputRefValue.value) {
                handleClear();
              }
            }}
            endAdornment={
              <IconButton size="small" onClick={handleClear} className="clear-icon">
                <CloseCircleFillIcon size={18} />
              </IconButton>
            }
          />
        </Box>
        {menu?.options && menu?.options?.length > 0 && setMenu && (
          <Box ml={1} title="Sort By">
            <Sort
              label="Group By"
              icon={<ListUnorderedIcon size={20} />}
              menu={menu}
              setMenu={setMenu}
            />
          </Box>
        )}
      </Box>
    );
  },
);

const SearchInput = styled(InputBase, { label: 'SearchInput' })(({ theme }) => ({
  borderRadius: 8,
  border: `1px solid transparent`,
  marginRight: 8,
  padding: '4px 16px',
  backgroundColor: theme.palette.custom.white,
  borderColor: `${theme.palette.custom.platinum}`,
  transition: '0.3s',
  '&:focus-within': {
    borderColor: `${theme.palette.custom.mistBlue} !important`,
    backgroundColor: theme.palette.custom.white,
  },
  '&:has(.MuiInputBase-input:placeholder-shown) .clear-icon': {
    display: 'none',
  },
}));

export default InsightsSearch;
